import { Chart, IChartOptions } from "devextreme-react/chart";

interface PromineoChartProps {
  chartOptions?: IChartOptions;
  children?: any;
}

export default function PromineoChart(props: PromineoChartProps) {
  const { chartOptions, children } = props;
  return <Chart {...chartOptions}>{children}</Chart>;
}
